import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { Chip } from '@feathr/components';
import { EPlatforms, platformIconMap } from '@feathr/extender/styles/platform';

export interface IProps {
  readonly platform: keyof typeof EPlatforms;
}

function PlatformChip({ platform }: IProps): JSX.Element {
  const platformIcon = platformIconMap[platform];

  return (
    <Chip prefix={platformIcon ? <FontAwesomeIcon icon={platformIcon} /> : undefined}>
      {EPlatforms[platform] || 'Other'}
    </Chip>
  );
}

export default observer(PlatformChip);
